import PingApi from "./apis/PingApi";
import ProfilApi from "./apis/ProfilApi";
import ConcoursApi from "./apis/ConcoursApi";
import ChallengeApi from "./apis/ChallengeApi";
import ShopApi from "./apis/ShopApi";
import ObjectifMonitoringApi from "./apis/ObjectifMonitoringApi";

//Permet d'acceder à toutes les APIs
export default {

    //Permet d'effectuer un ping sur l'api
    getPingApi() {
        return PingApi;
    },

    //Permet d'effectuer les opérations concernant le profil de l'utilisateur
    getProfilApi(){
        return ProfilApi;
    },

    //Permet d'effectuer les actions concernant les concours
    getConcoursApi(){
        return ConcoursApi;
    },

    //Permet d'effectuer les actions concernant les challenges
    getChallengeApi(){
      return ChallengeApi;
    },

    getShopApi(){
        return ShopApi;
    },

    getObjectifMonitoringApi(){
        return ObjectifMonitoringApi;
    }
}
